<!-- src/components/ProfitCalculator/CalculatorResult.vue -->
<template>
  <el-form-item label="计算结果">
    <div class="result">
      <p v-for="(item, index) in results" :key="index">
        {{ item.label }}: <strong>{{ item.value }} {{ item.unit }}</strong>
      </p>
    </div>
  </el-form-item>
</template>

<script>
export default {
  name: 'CalculatorResult',
  props: {
    results: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.result {
  background: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
}

.result p {
  margin: 10px 0;
  font-size: 16px;
}

.result strong {
  color: #409eff;
}
</style>
